import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import logo from '../assets/images/ArdeviaLogo_white.png';

const Header = (props) => (
    <header id="header" className="alt" >
        <Link to="/" className="logo">
            <img src={logo} style={{ height: '42px', marginTop: '4px', marginRight: '2px' }} alt="Ardevia" />
            <span style={{ color: '#E0E0E0', textAlign: 'right', lineHeight: '10px' }}>by Dany Wyss</span>
        </Link>
        <nav>
            <a className="menu-link" onClick={props.onToggleMenu} href="javascript:;">Menu</a>
        </nav>
    </header>
)

Header.propTypes = {
    onToggleMenu: PropTypes.func
}

export default Header
